import React from 'react';
import { ApButtonMain, ApLoaderDefault } from '@alixpartners/ui-components';

import {
  Header,
  ReportLandingContainer,
  CentralContent,
  FooterContent,
} from './ReportLanding.style';

interface IReportLandingProps {
  setLandingPage: () => void;
  showLoading?: boolean;
}

// TO DO
// Move the bottom two new logos to the component library
export const ReportLanding = ({
  setLandingPage,
  showLoading,
}: IReportLandingProps) => {
  return (
    <ReportLandingContainer>
      <CentralContent>
        <Header>Working Capital</Header>
        {showLoading ? (
          <ApButtonMain disabled={true}>
            <ApLoaderDefault loaderSize="sm" />
            <span style={{ marginLeft: 12 }}>Start Analysis</span>
          </ApButtonMain>
        ) : (
          <ApButtonMain iconName="bar_chart" onClick={setLandingPage}>
            Start Analysis
          </ApButtonMain>
        )}
      </CentralContent>
      <FooterContent>
        <img src="/img/ap_logo_grey.svg" alt="AlixPartners" />
      </FooterContent>
    </ReportLandingContainer>
  );
};
